import { breakpoints } from "@certn/cascadia-tokens";
import { css } from "@emotion/css";
import { PropsWithChildren } from "react";

import { useMediaQuery } from "../components/utils";

const screenSizes = Object.keys(breakpoints);

interface Props extends PropsWithChildren {
  sm?: boolean;
  md?: boolean;
  lg?: boolean;
  xl?: boolean;
  type?: "hide" | "show";
  className?: string;
}

export function MediaQuery(props: Props) {
  const { mediaQuery } = useMediaQuery();

  const { type = "show", children, className } = props;

  const display = screenSizes.map((size) => {
    const prop = size.split("-").at(-1);
    if (type === "show") {
      return prop && prop in props ? "block" : "none";
    } else {
      return prop && prop in props ? "none" : "block";
    }
  });

  return (
    <div
      className={css(
        className,
        mediaQuery({
          display,
        })
      )}
    >
      {children}
    </div>
  );
}
